module.exports = __webpack_public_path__ + "img/bg.003997a9.png";